"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SsoError = void 0;
/**
 * These are the expected SSO errors and not a complete list.
 */
var SsoError;
(function (SsoError) {
    SsoError["NEEDS_EMAIL_VERIFICATION"] = "needs_email_verification";
    SsoError["QUICKBOOKS_FAILED"] = "quickbooks_failed";
    SsoError["UNKNOWN_ERROR"] = "unknown_error";
})(SsoError || (exports.SsoError = SsoError = {}));
